module.exports = __webpack_public_path__ + "images/dice-icon-f04a6d235f5f1b22d3142864822e1f0f.png";